<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <SqlQuery
          :database="database"
          :query="query"
          :args="args"
          :show-debugging="true"
          :show-csv="true"
          :readonly="false"
          run-text="Run Query"
          class="m-4"
        />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import SqlQuery from '../utility/SqlQuery';

export default {
  components: {
    SqlQuery,
  },
  data() {
    return {
      database: 'fishbowl',
      query: '',
      args: [],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/it-info/QueryPassthrough.vue